module.exports = __webpack_public_path__ + "assets/ic-twitter.6d52331b.svg";